export default "__VITE_ASSET__34c90e9b__"